export const SET_UPLOAD_SPEED = 'network/SET_UPLOAD_SPEED';
export const SAVING_OFFLINE_DISCLO = 'network/SAVING_OFFLINE_DISCLO';
export const SAVING_OFFLINE_ANNOUN = 'network/SAVING_OFFLINE_ANNOUN';
export const RESET_DATA_DISCLOSURES = 'network/RESET_DATA_DISCLOSURES';
export const RESET_DATA_ANNOUNCEMENTS = 'network/RESET_DATA_ANNOUNCEMENTS';
